export enum RoutePathsEnum{
  Home="/",
  Containers="/containers",
  ItemOrders="/itemorders",
  ItemOrdersCreate="/itemorders/add",
  ItemOrdersEdit="/itemorders/update",
  WorkOrders="/workorders",
  WorkOrderRaise="/raiseworkorder",
  WorkOrderView="/workorder",
  WorkOrderModify="/modifyworkorder",
  WorkOrderComplete="/completeworkorder",
  Settings="/settings",
  SettingsRegions="/settings/regions",
  SettingsRegionsAdd="/settings/regions/add",
  SettingsRegionsUpdate="/settings/regions/edit",
  SettingsHwrcSites="/settings/hwrcsites",
  SettingsHwrcSitesAdd="/settings/hwrcsites/add",
  SettingsHwrcSitesUpdate="/settings/hwrcsites/update",
  SettingsNonWorkingPeriods="/settings/nonworkingperiods",
  SettingsNonWorkingPeriodsAdd="/settings/nonworkingperiods/add",
  SettingsNonWorkingPeriodsUpdate="/settings/nonworkingperiods/update",
  SettingsDisposalSites="/settings/disposalsites",
  SettingsDisposalSitesAdd="/settings/disposalsites/add",
  SettingsDisposalSitesUpdate="/settings/disposalsites/update",
  SettingsSystemSettings="/settings/systemsettings",
  SettingsSetThreshold="/settings/setthreshold",
  SettingsSla="/settings/sla",
  SettingsSlaUpdate="/settings/sla/editsla",
  SettingsSlaDwhUpdate="/settings/sla/editdwh",
  SettingsCollectors="/settings/collectors",
  SettingsCollectorsVehiclesAdd="/settings/collectors/vehicles/add",
  SettingsCollectorsVehiclesUpdate="/settings/collectors/vehicles/update",
  SettingsCollectorsProvidersAdd="/settings/collectors/providers/add",
  SettingsCollectorsProvidersUpdate="/settings/collectors/providers/update",
  SiteDiaryLandingPage="/diary",
  AuthorisedVisitorTemporaryWorkerAdd="/diary/authorisedvisitortemporaryworker/add",
  AuthorisedVisitorTemporaryWorkerEdit="/diary/authorisedvisitortemporaryworker/update",
  AuthorisedMaintenanceAdd="/diary/authorisedmaintenance/add",
  AuthorisedMaintenanceEdit="/diary/authorisedmaintenance/update",
  SiteDiaryAddStaffOnSite="/diary/staffonsite/add",
  SiteDiaryEditStaffOnSite="/diary/staffonsite/edit",
  SiteDiaryAddEventsAndIncidents="/diary/eventincident/add",
  SiteDiaryEditEventsAndIncidents="/diary/eventincident/edit",
  Map="/map",
  Unauthorised = "/unauthorised",
  Logout="/logout"
}
